import VModal from '@/vuetify_custom/v-modal_v1'
import { createSalaryAdjustV2 } from '@/views/fin/salaryadministration/utils.js'
import VTable from '@/vuetify_custom/v-table/v2'
import {VIcon} from 'vuetify/lib'
import employmentTypesMixin from '@/views/fin/salaryadministration/common_mixins.js'
import { formattingNumber } from '@/libs/util'
import { getsafe } from '@/libs/util.js'
import styles from '../index.module.less'
import s_styles from './pay.module.less'
import { VBtnToggle, VBtn} from 'vuetify/lib'
export default {
    mixins:[employmentTypesMixin],
    props: {
        workingDayTip: {
            type: String
        }
    },
    data() {
        this.cache = {}
        return {
            show:false,
            saveLoading: false,
            params: createSalaryAdjustV2(),
            sourceData: {

            },
            records: [],
            check_list: [],
            selected: 0,
            fields_hash: {},
            contain_width: 0,
            colunm_width: 0,
            expand_hash: {}
        }
    },
    computed:{
        records_hash() {
            if (!this.records.length) {
                return {}
            }

            return this.records.reduce((t, i) => {
                t[i.customer_id] = i
                return t
            }, {})
        },
        headers() {
            return [
                {
                    text: '类别',
                    align: 'center',
                    width: 120,
                    value: '_type',
                    fixed: 'left',
                    render: (...arg) => {
                        const index = arg[4].indexOf(arg[2])
                        return <span>{index === 0 ? '预估' : '实际'}</span> 
                    },
                },
                {
                    text: '工号',
                    align: 'center',
                    value: 'job_number',
                    width: 120,
                },
           
                {
                    text: '身份证',
                    align: 'center',
                    value: 'id_number',
                    width: 120,
           
                },
                {
                    text: '银行卡号',
                    align: 'center',
                    value: 'bank_number',
                    width: 120,
                },
                {
                    text: '劳动关系所在公司	',
                    align: 'center',
                    value: 'company_name',
                    width: 140,
                },
                {
                    text: '状态',
                    align: 'center',
                    value: 'emp_status',
                    width: 120,
                    // status_list
                },
                {
                    text: '缴存地',
                    align: 'center',
                    value: 'payment_place',
                    width: 120,
                },
                {
                    text: '分类',
                    align: 'center',
                    value: 'employment_type_id',
                    width: 120,
                    render: (_, __, target) => <span>{this.getEmployeeType(target)}</span>
                },
                {
                    text: '团队',
                    align: 'center',
                    value: 'team_name',
                    width: 120,
                },
                {
                    text: '当月应出勤天数',
                    align: 'center',
                    value: 'should_working_day',
                    width: 120,
                },
                {
                    text: '当月入离职调整天数',
                    align: 'center',
                    value: 'enter_quit_adjust_day',
                    width: 140,
                    is_cor_work_day:true
                },
                {
                    text: '当月请假需扣除天数',
                    align: 'center',
                    value: 'leave_day',
                    width: 140,
                    is_cor_work_day:true
                },
                {
                    text: '上月补发天数',
                    align: 'center',
                    value: 'last_month_working_day',
                    width: 120,
                    is_cor_work_day:true
                },
                {
                    text: '当月出勤调整天数',
                    align: 'center',
                    value: 'work_day',
                    width: 150,
                },
               
            
                {
                    text: '税前基准工资',
                    
                    value: 'salary',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '入离职调整工资',
                    
                    value: 'enter_quit_adjust_salary',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '上月补发工资',
                    
                    value: 'last_month_supply_salary',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '请假扣款',
                    
                    value: 'leave_deduct_salary',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '其他发放',
                    
                    value: 'other_subsidy',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '当期调整合计',
                    
                    value: 'current_period_adjust',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '标准餐补',
                    
                    value: 'meal_subsidy_base',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '餐补',
                    
                    value: 'meal_subsidy',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '推荐奖',
                    
                    value: 'recommend_award',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '税前工资',
                    value: 'customer_salary',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '社保基数-养老',
                    
                    value: 'endowment_insurance_payment_base',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '社保基数-其他',
                    
                    value: 'medical_insurance_payment_base',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '公积金基数',
                    
                    value: 'accumulation_fund_payment_base',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '养老单位缴费金额',
                    
                    value: 'company_endowment_amount',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '医疗单位缴费金额',
                    
                    value: 'company_medical_amount',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '生育单位缴费金额',
                    
                    value: 'company_maternity_amount',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '失业单位缴费金额',
                    
                    value: 'company_unemployment_amount',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '工伤单位缴费金额',
                    
                    value: 'company_industrial_injury_amount',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '补充医疗单位缴费金额',
                    value: 'company_supplementary_medical_amount',
                    width: 160,
                    align:'center',
                    render: (_, __, target) => {
                        if (target.payment_place === '北京') {
                            return <span>-</span>
                        }
                        return <span >{ formattingNumber(target.company_supplementary_medical_amount || 0, 2)}</span>
                    },
                },
                {
                    text: '公积金单位缴存额',
                    
                    value: 'company_accumulation_fund_amount',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '养老个人缴费金额',
                    
                    value: 'person_endowment_amount',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '医疗个人缴费金额',
                    
                    value: 'person_medical_amount',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '失业个人缴费金额',
                    
                    value: 'person_unemployment_amount',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '补充医疗个人缴费金额',
                    value: 'person_supplementary_medical_amount',
                    width: 160,
                    align:'center',
                    render: (_, __, target) => {
                        if (target.payment_place === '成都') {
                            return <span>-</span>
                        }
                        return <span >{ formattingNumber(target.person_supplementary_medical_amount, 2)}</span>
                    },
                },
                {
                    text: '公积金个人缴存额',
                    
                    value: 'person_accumulation_fund_amount',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '个人扣除',
                    
                    value: 'person_deduct_amount',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '子女教育',
                    
                    value: 'child_edu_deduct',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '住房贷款利息',
                    
                    value: 'housing_loan_deduct',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '住房租金',
                    
                    value: 'housing_rent_deduct',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '赡养老人',
                    
                    value: 'support_older_deduct',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '继续教育',
                    
                    value: 'continuing_edu_deduct',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '婴幼儿照护',
                    
                    value: 'baby_tend_deduct',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '专项附加扣除汇总',
                    
                    value: 'special_deduct_total',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '个人养老金',
                    
                    value: 'personal_pension',
                    width: 130,
                    type: 'money_field', align:'center'
                },
                {
                    text: '扣除三险一金后月税前工资',
                    
                    value: 'pre_tax_salary',
                    width: 180,
                    type: 'money_field', align:'center'
                },
                {
                    text: '个税',
                    
                    value: 'individual_tax',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '税后工资',
                    
                    value: 'after_tax_salary',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '公司社保合计',
                    
                    value: 'company_social_security_total',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '个人社保合计',
                    
                    value: 'person_social_security_total',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '社保合计',
                    
                    value: 'social_security_total',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                {
                    text: '公积金合计',
                    value: 'accumulation_fund_total',
                    width: 120,
                    type: 'money_field', align:'center'
                },
                
            ].map(i => {
                const _i = {...i}
                switch (i.value) {
                    case '_type':
                        break
                      
                   
                    default:
                        _i.render = this.isDiffRender({
                            diff_key: i.value,
                            key:i.value,
                            type: i.type,
                        })
                        break;
                }
                return _i
            })
        }

    },
    mounted() {
   
     // this.show = false
    },
    methods: {
        filterHeaderPoxy({headers, customer_id}) {
            const selected = this.selected
           const is_expand = this.expand_hash[customer_id]
            if (selected !== 0 || is_expand === undefined) {
                return headers
            }
        
            const _headers = headers.filter(i => {
                if (!i.is_cor_work_day) {
                    return true
                }
                return is_expand
            }).map((i) => {
                if (i.value === 'work_day') {
                    return {
                        ...i,
                        headerRender:({header}) => {
                            return <span>
                                <VIcon 
                                    small 
                                    style="cursor: pointer;" 
                                    color="primary"
                                    on={{
                                        click: () => {
                                            this.expand_hash[customer_id] = !this.expand_hash[customer_id]
                                        }
                                    }}
                                    >{ this.expand_hash[customer_id] ? 'mdi-arrow-collapse-horizontal' : 'mdi-arrow-expand-horizontal'}</VIcon>{header.text}</span>
                        },
                    }
                }
                return i
            })
            return _headers
        },  
        filterHeader({headers, data_list, selected = this.selected}) {
            const _headers = []
            let max_width = 120
            if (!selected) {
                return headers
            }
            headers.forEach((header) => {
                if (header.value === '_type' || data_list[0][header.value] !== data_list[1][header.value]) {
                    _headers.push(header)
                    max_width = math.max(max_width, header.width)
                }
            });
            return {_headers, max_width}
        },
        isDiffRender({
            key,
            diff_key, 
            dis_key,
            type
        }) {
            return (...arg) => {
                if (!dis_key) {
                    dis_key = diff_key
                }
              
                const val = getsafe(arg, `2.${dis_key}`)
                const customer_id = getsafe(arg, '2.customer_id')
                const target = arg[2]
                const arr = arg[4]
                const is_not_queal = this.isNotEqual(customer_id, arr, diff_key)
                const is_bj_company_sup = key === 'company_supplementary_medical_amount' && target.payment_place === '北京'
                const is_cd_person_sup = key === 'person_supplementary_medical_amount' && target.payment_place === '成都'
                if (is_bj_company_sup || is_cd_person_sup) {
                    return <span>-</span>
                }
                if (key === 'employment_type_id') {
                    return <span style={`color: ${is_not_queal ? 'red' : ''}`}>{this.getEmployeeType(target)}</span>
                }
                if (type === 'money_field') {
                    return <span style={`color: ${is_not_queal ? 'red' : ''}`}>{formattingNumber(val, 2)}</span>
                }

                if (key === 'company_supplementary_medical_amount') {
                    if (target.payment_place === '北京') {
                        return <span>-</span>
                    }
                    return <span style={`color: ${is_not_queal ? 'red' : ''}`}>{formattingNumber(val, 2)}</span>
                }
                
                return <span style={`color: ${is_not_queal ? 'red' : ''}`}>{val}</span>
        }
        },
        isNotEqual(customer_id, arr, key) {
            if (this.cache[`${customer_id}-${key}`] === undefined) {
                this.cache[`${customer_id}-${key}`] = getsafe(arr[0], key) !== getsafe(arr[1], key)
            }
            return this.cache[`${customer_id}-${key}`]
        },
        handleParams({
            records,
            check_list
        } = {}) {
            let max_c_len = 0
            let max_width = 120
            const records_hash = records && records.length && records.reduce((t, i) => {
                t[i.customer_id] = i
                return t   
            }, {}) || {}
            check_list.forEach(i => {
                 const t = this.filterHeader({
                    headers: this.headers,
                    data_list: [
                        i,
                        records_hash[i.customer_id] || {}
                    ],
                    selected: true
                })
                const header_clone = t._headers
                 max_width = math.max(t.max_width, max_width) 
          
                if (header_clone && header_clone.length > 1) {
                    this.fields_hash[i.customer_id] = header_clone
                    max_c_len = Math.max(max_c_len, header_clone.length)
                }   

            })
         
            this.contain_width = this.$refs['table-contain'].offsetWidth
            this.colunm_width = Math.max(Math.floor(this.contain_width / max_c_len), max_width)
            this.records = records
            this.check_list = check_list
            
          
        },
        edit({
            records,
            check_list
        } = {}) {
            setTimeout(() => this.handleParams({ records, check_list}))
            this.fields_hash = {}
            this.expand_hash = {}
            const expand_hash = {}
            this.selected = 0
            this.show = true
            this.cache = {}  
            records.forEach(i => {
                expand_hash[i.customer_id] = false
            })
            this.expand_hash = expand_hash
        },
    },
    render() {
        return <VModal 
        fullscreen

        v-model={this.show}
        title='数据对比'
        loading={this.saveLoading}
        cancelText=""
        okText="关闭"
        ref="modal"
        on={{
          ok: () => {
              this.show = false
          }
        }}
    >
        <div class={styles['modal-contain']} >
            <div style="padding-bottom:10px">
                <VBtnToggle v-model={this.selected}>
                    <VBtn small>
                        全部数据
                    </VBtn>
                    <VBtn small>
                        差异数据
                    </VBtn>
                </VBtnToggle>
            </div>
            <div ref="table-contain">
            {this.check_list.filter(i => {
                if (this.selected === 0) {
                    return true
                }
                return !!this.fields_hash[i.customer_id]
            }).map((target) => {
                let headers = this.headers
                let width = '100%'
                let colunm_width = 120
                if (this.selected) {// 当选择查看对比数据时
                    // 每一列的长度
                    colunm_width = Math.max(colunm_width, this.colunm_width)
                    headers = this.fields_hash[target.customer_id] || this.headers
                    headers = headers.map(i => ({
                        ...i,
                        width: colunm_width
                    }))
                    // 容器的长度
                    width = this.contain_width < headers.length * colunm_width ? width : `${headers.length * colunm_width}px`
                }
                return <div style={`margin-bottom:30px;width:${width}`} key={target.id}>
                         <p class={[s_styles['p-n'], s_styles['p-b']]}>{target.customer_name}</p>
                         <VTable 
                            headers={this.filterHeaderPoxy({headers, customer_id:target.customer_id})}
                            desserts={[
                                target,
                                this.records_hash[target.customer_id] || {}
                            ]}
                         />
                    </div>
            })} 
            </div>
        </div>
    </VModal>
    }
}